/*
 * @Author: Czy
 * @Date: 2021-11-17 09:05:16
 * @LastEditTime: 2021-12-16 16:28:18
 * @FilePath: /plant-protection-association/src/main.js
 *  
 */
import Vue from 'vue'
import App from './App'
import MetaInfo from 'vue-meta-info'

/* 路由 */
import router from './router'

/* axios */
import axios from './api'
// import api from './api/api'
Vue.prototype.http = axios;
Vue.prototype.bus = new Vue()
// Vue.prototype.api = api;

/* swiper */
import 'swiper/css/swiper.css'

/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'



import VueNotification from "@kugatsu/vuenotification";
Vue.use(MetaInfo)

Vue.use(VueNotification, {
    timer: 20,
    position: 'topCenter',
    error: {
        color: "#F56C6C",
        background: "#FFEFF0"
    }
});

/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name, Header)

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, { ak: 'YILzEmWtc7GUGi5QIOAQtcHdzTGQ7YMK' })


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name, Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name, GoTop)

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next();
});

router.afterEach((to, from) => {
    window.scrollTo(0, 0)
})

// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })
new Vue({
  el: '#app',
  router,
  components: { App },
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js